
















































	import { Watch, BaseTLComponent, Component, Prop, ObjectTypesHelper } from "../../Infrastructure/CorBase/CoreBase";

	@Component
	export default class BaseTLGrid extends BaseTLComponent {

		@Prop({ required: true }) itemsData: any; //zakladni datova napln
		@Prop({ type: Array, required: false }) selectedRowMain!: number[];
		@Prop({ required: true }) gridFields: any; //odkud co namapovat
		@Prop({ type: String, required: true, default: "" }) orderBy!: string; //orderd by
		@Prop({ type: Boolean, required: true, default: false }) orderDesc!: boolean; //jednoznačný nazev tabulky
		//@Prop({ type: Number, required: false, default: ObjectTypesHelper.ObjectTypeEnum.Content }) objectType?: ObjectTypesHelper.ObjectTypeEnum;
		@Prop({ type: String, required: true, default: "250px" }) maxHeight!: string; //maximalni vyska
  
		@Prop({ type: Number, required: false }) objectType?: ObjectTypesHelper.ObjectTypeEnum;
		//z jakoho pole brat data
		fieldDescription1 = '';
		fieldDescription2 = '';
		fieldName = '';
		fieldNameTask = '';
		fieldList = '';
		fieldTypeFile = '';
		fieldImage = '';
		fieldTags = '';
		selectOrder = '';
		orderOptions = [{ value: "1", text: "neco" }];
		actualOrder = '';

		objectContent = ObjectTypesHelper.ObjectTypeEnum.Content;
		objectReceiver = ObjectTypesHelper.ObjectTypeEnum.Receiver;

		setMaxHeight():string {
			var prepNum = this.maxHeight.replace('px', '');
			var maxHeight = Number(prepNum) - 65;
			return "max-height:" + maxHeight+'px';
		}		

        detailTag(id: any): void {
            this.$emit('detailTag', id);
        }

		selectItemGrid(id: number): void {
			this.$emit('selectItemGrid', id);
		}

		detailClick(id: number): void {
			this.$emit('detailClick', id);
		}

        deleteClick(id: number): void {
            this.$emit('deleteClick', id);
        }

		goBackTagDetail(item: any) {
			for (var i = 0; i < this.itemsData.length; i++) {
				var changeItem = (this.itemsData[i].tags as Array<any>).filter((c: any) => c.id == item.id);
				if (changeItem.length > 0) {
					changeItem[0].name = item.name;
					changeItem[0].color = item.color;
				}
			}
		}	

		itemsDataOrdered() {		
			var items = (this.itemsData as Array<any>);	

			if (this.orderDesc) {
				return items.sort((a: any, b: any) => (b[this.orderBy] ? b[this.orderBy].localeCompare(a[this.orderBy]) : -1));
			}
			else {//nahoru sipka asc
				return items.sort((a: any, b: any) => (a[this.orderBy] ? a[this.orderBy].localeCompare(b[this.orderBy]) : -1));
			}	

		}

		changeOrderAsd(asc: boolean): void {
			this.$emit('changeOrderAscGrid', asc);
		}

		changeOrder(item: any) {
			this.actualOrder = item;
			this.$emit('changeOrderGrid', this.actualOrder);
		}

		getDesign() {
			return (this.gridFields as Array<any>).filter(c => c.key == 'design')[0].design;		
		}

		getDataItemArray(item: any, name: string): Array<any> {
			if (name == '') {
				return [];
			}
			return (item[name] as Array<any>);
		}

		getDataItem(item: any, name: string): string {
			if (name == '') {
				return '';
			}
			return String(item[name]);
		}

		getDataItemNumber(item: any, name: string): number {
			if (name == '') {
				return -1;
			}
			return Number(item[name]);
		}

		getFieldName(name: string): string {
			if (this.gridFields == undefined) {
				return '';
			}
			var field = (this.gridFields as Array<any>).filter(c => c.key == name);
			if (field.length == 0) {
				return '';
			}
			else {
				return field[0]['data'];
			}
		}



		setDropDownList(index: number) {
			var dropDownElement = document.getElementById('orderDropDownId');
			(dropDownElement as HTMLSelectElement).selectedIndex = index;
		}

		selectedDrop: number = -1;
		initOrder() {		
			if (this.gridFields != undefined) {
				this.orderOptions = [];
				var orderFields = (this.gridFields as Array<any>).filter(c => c.sortable == true);		


				for (var i = 0; i < orderFields.length; i++) {
					this.orderOptions.push({ value: orderFields[i].data, text: orderFields[i].label });
					if (orderFields[i].data == this.orderBy) {
						this.selectedDrop = i;
					}
				}

				this.$nextTick(function () {
					this.setDropDownList(this.selectedDrop);
				});
			}

			//nastavení co je v tabulce

		}

		created() {	
			this.fieldDescription1 = this.getFieldName('description1');
			this.fieldDescription2 = this.getFieldName('description2');
			this.fieldName = this.getFieldName('name');
			this.fieldNameTask = this.getFieldName('firstTaskName');
			this.fieldList = this.getFieldName('taskList');
			this.fieldTypeFile = this.getFieldName('typeFile');
			this.fieldImage = this.getFieldName('image');
			this.fieldTags = this.getFieldName('tags');


			this.initOrder();
		};

		isSelected(id: number): boolean {
			return this.selectedRowMain.indexOf(id) != -1;
		}

		//@ts-ignore
		@Watch('$store.state.currentLanguage')
		changeFieldsAfterChangeLanguage(value: boolean, oldValue: boolean) {
			this.initOrder();
		}

	};
